import Vue from "vue";
Vue.prototype._nsl$1 = 0;

import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import { $blogroll_link } from "@/api/index";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    saveUserOA: 1, // 账号type 1=设计岛,2=OA
    // 用户账号
    userAccount: "",
    checked: true,
    // 个人中心 权限
    personalCenterPermissions: [],
    // 用户信息
    userInfo: {
      token: null,
    },
    crminfo: {},
    crminfo_cd: "",
    // 订单草稿
    draftOrder: {},
    role_id: [
      1, // 经销商
      2, // 设计师
      3, // 区域负责人
      4, // 内部人员
      5, // 部门负责人
      6, // 分销商
    ],
    // 订单操作
    orderOperate: {
      39: "取消",
      40: "详情",
      41: "支付",
      42: "验收",
      43: "评价",
      44: "确认报价",
      45: "审核",
      46: "分配",
      47: "再次分配",
      48: "分配协助",
      49: "拒绝协助",
      50: "接收协助",
      51: "拒绝分配",
      52: "接收分配",
      53: "申请协助",
      54: "上传方案",
      55: "修改",
      56: "报价",
      57: "继续设计",
      58: "撤单",
    },
    // 订单状态
    ordersStatus: {
      1: "草稿箱",
      2: "模板",
      3: "未分院",
      4: "待分配",
      5: "待确定", //待沟通
      6: "待报价", //待确定
      7: "待支付",
      8: "设计中",
      9: "审核中", //待审核
      10: "修改中", //待修改
      12: "已取消",
      13: "已超时",
      15: "已完成",
      16: "已拒绝",
      18: "验收中", //待验收
      20: "已验收", //待评价
      21: "已成单",
      99: "沟通中",
      22: "撤单中",
      23: "已撤单",
      24: "已拒绝",
    },
    // 是否展示滚动条
    showHeader: false,
    headPlaceholder:false,
    // 友情链接
    blogroll: []
  },
  mutations: {
    setPermissions(state, data) {
      state.personalCenterPermissions = data;
    },
    clearUserInfo(state, data) {
      state.userInfo = {
        token: null,
      };
      window.sessionStorage.removeItem("cdntoken");
    },
    SetUserInfo(state, data) {
      state.userInfo = data;
    },
    SetChecked(state, data) {
      state.checked = data;
    },
    saveUser(state, data) {
      state.userAccount = data;
    },
    saveUserOA(state, data) {
      state.saveUserOA = data;
    },
    saveCrmInfo(state, data = {}) {
      state.crminfo = data;
    },
    changeCrminfoCd(state, data = "") {
      state.crminfo_cd = data;
    },
    setHeaderShow(state, value) {
      state.showHeader = value
    },
    setBlogroll(state, value) {
      state.blogroll = value
    },
    setHeadPlaceholder(state, value) {
      state.headPlaceholder = value
    }
  },
  actions: {
    getBlogroll({ commit }) {
      $blogroll_link().then(res => {
        commit('setBlogroll',res.data)
      })
    }
  },
  modules: {},
  getters: {
    userInfo: (state) => state.data,
    checked: (state) => state.data,
    blogroll: (state) => state.blogroll
  },
  plugins: [createPersistedState()],
});
